import {
  EMPLOYEE_SHIFT_SCHEDULE_FETCHING,
  EMPLOYEE_SHIFT_SCHEDULE_FAILED,
  EMPLOYEE_SHIFT_SCHEDULE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: [],
  isFetching: true,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case EMPLOYEE_SHIFT_SCHEDULE_FETCHING:
      return { ...state, result: [], isFetching: true, isError: false };
    case EMPLOYEE_SHIFT_SCHEDULE_FAILED:
      return { ...state, result: [], isFetching: false, isError: true };
    case EMPLOYEE_SHIFT_SCHEDULE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
